import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationService } from '../../services/confirmation.service';

@Component({
	selector: 'ziggy-confirm-dialog',
	
	imports: [CommonModule],
	template: `
		@if (srv.config(); as cfg) {
			<dialog #modalRef class="ziggy-dialog-bottom modal-open">
				<div class="modal-box ziggy-modal-box">
					<h3 class="ziggy-modal-title">{{ cfg.title }}</h3>
					<p class="ziggy-modal-content" [innerHTML]="cfg.message"></p>
					
					<div class="ziggy-modal-footer">
						<button
							class="btn btn-ghost btn-sm"
							[ngClass]="{
								'btn-error': cfg.rejectSeverity === 'danger',
								'btn-warning': cfg.rejectSeverity === 'warning',
								'btn-primary': cfg.rejectSeverity === 'info'
							}"
							(click)="srv.reject()"
						>
							{{ cfg.rejectLabel }}
						</button>
						
						<button 
							class="ziggy-action-btn" 
							[ngClass]="{
								'btn-error': cfg.acceptSeverity === 'danger',
								'btn-warning': cfg.acceptSeverity === 'warning',
								'btn-primary': cfg.acceptSeverity === 'info'
							}"
							(click)="srv.accept()"
						>
							{{ cfg.acceptLabel }}
						</button>
					</div>
				</div>

				<form method="dialog" class="modal-backdrop">
					<button (click)="srv.reject()">close</button>
				</form>
			</dialog>
		}
	`
})
export class ConfirmDialogComponent {
	public srv = inject(ConfirmationService);
}